import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useParams } from "react-router-dom";
import classNames from "classnames";
import { setClearDemoSite } from "../../redux/appReducer";
import { confirmStandMedia } from "../../api/stand";
import { ButtonLoader } from "../shared";
import { successMessage } from "../../utils/successMessage";

const NavStandIcons = ({ statusType }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const confirmedStandMediaIds = useSelector(
    (state) => state.events.confirmedStandMediaIds
  );

  const isStandMediaConfirmed = confirmedStandMediaIds.some((i) => i === id);

  const [isLoading, setIsLoading] = useState(false);

  const role = useSelector((state) => state.user.profile.role);

  const history = useHistory();

  const isActual = statusType === "actual";
  const isPast = statusType === "pass";
  const isFilling = statusType === "filling";
  const isRequest = statusType === "request";

  const getActiveIcon = (url) => {
    if (history.location.pathname.includes(url)) {
      return "#C90113";
    } else {
      return "#727E8E";
    }
  };

  let type = "event";
  if (role === "участник") {
    type = "stand";
  }

  const onSendClick = async () => {
    try {
      setIsLoading(true);
      await confirmStandMedia({ standId: id });
      setIsLoading(false);
      successMessage("Стенд успешно сохранен");

      history.push("/favorite/filling");
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  return (
    <>
      {(isActual || isRequest || isFilling) && (
        <NavLink to={`/${type}/${id}/settings/model`} activeClassName="active">
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill={getActiveIcon(`settings/model`)}
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.4026 14.4676L9.65255 2.78255C9.58714 2.66713 9.49228 2.57113 9.37765 2.50433C9.26302 2.43754 9.13272 2.40234 9.00005 2.40234C8.86738 2.40234 8.73708 2.43754 8.62246 2.50433C8.50783 2.57113 8.41296 2.66713 8.34755 2.78255L1.59755 14.4676C1.53173 14.5816 1.49707 14.7109 1.49707 14.8426C1.49707 14.9742 1.53173 15.1035 1.59755 15.2176C1.66363 15.332 1.75878 15.427 1.87336 15.4928C1.98794 15.5587 2.11789 15.5931 2.25005 15.5926H15.7501C15.8822 15.5931 16.0122 15.5587 16.1267 15.4928C16.2413 15.427 16.3365 15.332 16.4026 15.2176C16.4684 15.1035 16.503 14.9742 16.503 14.8426C16.503 14.7109 16.4684 14.5816 16.4026 14.4676ZM3.54755 14.0926L9.00005 4.65755L14.4526 14.0926H3.54755Z"
                    fill={getActiveIcon(`settings/model`)}
                  />
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">
              {role === "организатор" ? "Ресепшн" : "3D модель"}
            </div>
          </div>
        </NavLink>
      )}
      {isActual && (
        <NavLink to={`/${type}/${id}/settings/program/edit`} activeClassName="active">
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.75 7.5H7.5C7.69891 7.5 7.88968 7.42098 8.03033 7.28033C8.17098 7.13968 8.25 6.94891 8.25 6.75C8.25 6.55109 8.17098 6.36032 8.03033 6.21967C7.88968 6.07902 7.69891 6 7.5 6H6.75C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5ZM6.75 9C6.55109 9 6.36032 9.07902 6.21967 9.21967C6.07902 9.36032 6 9.55109 6 9.75C6 9.94891 6.07902 10.1397 6.21967 10.2803C6.36032 10.421 6.55109 10.5 6.75 10.5H11.25C11.4489 10.5 11.6397 10.421 11.7803 10.2803C11.921 10.1397 12 9.94891 12 9.75C12 9.55109 11.921 9.36032 11.7803 9.21967C11.6397 9.07902 11.4489 9 11.25 9H6.75ZM15 6.705C14.9922 6.6361 14.9771 6.56822 14.955 6.5025V6.435C14.9189 6.35788 14.8708 6.287 14.8125 6.225L10.3125 1.725C10.2505 1.66666 10.1796 1.61856 10.1025 1.5825C10.0801 1.57932 10.0574 1.57932 10.035 1.5825C9.95881 1.53881 9.87467 1.51076 9.7875 1.5H5.25C4.65326 1.5 4.08097 1.73705 3.65901 2.15901C3.23705 2.58097 3 3.15326 3 3.75V14.25C3 14.8467 3.23705 15.419 3.65901 15.841C4.08097 16.2629 4.65326 16.5 5.25 16.5H12.75C13.3467 16.5 13.919 16.2629 14.341 15.841C14.7629 15.419 15 14.8467 15 14.25V6.75C15 6.75 15 6.75 15 6.705ZM10.5 4.0575L12.4425 6H11.25C11.0511 6 10.8603 5.92098 10.7197 5.78033C10.579 5.63968 10.5 5.44891 10.5 5.25V4.0575ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H5.25C5.05109 15 4.86032 14.921 4.71967 14.7803C4.57902 14.6397 4.5 14.4489 4.5 14.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H9V5.25C9 5.84674 9.23705 6.41903 9.65901 6.84099C10.081 7.26295 10.6533 7.5 11.25 7.5H13.5V14.25ZM11.25 12H6.75C6.55109 12 6.36032 12.079 6.21967 12.2197C6.07902 12.3603 6 12.5511 6 12.75C6 12.9489 6.07902 13.1397 6.21967 13.2803C6.36032 13.421 6.55109 13.5 6.75 13.5H11.25C11.4489 13.5 11.6397 13.421 11.7803 13.2803C11.921 13.1397 12 12.9489 12 12.75C12 12.5511 11.921 12.3603 11.7803 12.2197C11.6397 12.079 11.4489 12 11.25 12Z"
                    fill={getActiveIcon(`settings/program`)}
                  />
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Программа</div>
          </div>
        </NavLink>
      )}
      {(isActual || isPast) && (
        <NavLink to={`/${type}/${id}/settings/mailing`} activeClassName="active">
          <div
            className={classNames("nav-profile__item", {
              active: history.location.pathname.includes(`settings/mailing`),
            })}
          >
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0)">
                    <path
                      d="M17.25 15.7502V14.2502C17.2495 13.5855 17.0283 12.9397 16.621 12.4144C16.2138 11.889 15.6436 11.5138 15 11.3477"
                      stroke={getActiveIcon(`settings/mailing`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12.75 15.75V14.25C12.75 13.4544 12.4339 12.6913 11.8713 12.1287C11.3087 11.5661 10.5456 11.25 9.75 11.25H3.75C2.95435 11.25 2.19129 11.5661 1.62868 12.1287C1.06607 12.6913 0.75 13.4544 0.75 14.25V15.75"
                      stroke={getActiveIcon(`settings/mailing`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 2.34766C12.6453 2.51288 13.2173 2.88818 13.6257 3.41439C14.0342 3.9406 14.2559 4.58778 14.2559 5.25391C14.2559 5.92003 14.0342 6.56722 13.6257 7.09342C13.2173 7.61963 12.6453 7.99493 12 8.16016"
                      stroke={getActiveIcon(`settings/mailing`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.75 8.25C8.40685 8.25 9.75 6.90685 9.75 5.25C9.75 3.59315 8.40685 2.25 6.75 2.25C5.09315 2.25 3.75 3.59315 3.75 5.25C3.75 6.90685 5.09315 8.25 6.75 8.25Z"
                      stroke={getActiveIcon(`settings/mailing`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect
                        width="18"
                        height="18"
                        fill={getActiveIcon(`settings/mailing`)}
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Рассылка</div>
          </div>
        </NavLink>
      )}
      {(isActual || isPast) && (
        <NavLink to={`/${type}/${id}/settings/contacts/list`} activeClassName="active">
          <div
            className={classNames("nav-profile__item", {
              active: history.location.pathname.includes(`settings/contacts`),
            })}
          >
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0)">
                    <path
                      d="M17.25 15.7502V14.2502C17.2495 13.5855 17.0283 12.9397 16.621 12.4144C16.2138 11.889 15.6436 11.5138 15 11.3477"
                      stroke={getActiveIcon(`settings/contacts`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12.75 15.75V14.25C12.75 13.4544 12.4339 12.6913 11.8713 12.1287C11.3087 11.5661 10.5456 11.25 9.75 11.25H3.75C2.95435 11.25 2.19129 11.5661 1.62868 12.1287C1.06607 12.6913 0.75 13.4544 0.75 14.25V15.75"
                      stroke={getActiveIcon(`settings/contacts`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 2.34766C12.6453 2.51288 13.2173 2.88818 13.6257 3.41439C14.0342 3.9406 14.2559 4.58778 14.2559 5.25391C14.2559 5.92003 14.0342 6.56722 13.6257 7.09342C13.2173 7.61963 12.6453 7.99493 12 8.16016"
                      stroke={getActiveIcon(`settings/contacts`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.75 8.25C8.40685 8.25 9.75 6.90685 9.75 5.25C9.75 3.59315 8.40685 2.25 6.75 2.25C5.09315 2.25 3.75 3.59315 3.75 5.25C3.75 6.90685 5.09315 8.25 6.75 8.25Z"
                      stroke={getActiveIcon(`settings/contacts`)}
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect
                        width="18"
                        height="18"
                        fill={getActiveIcon(`settings/contacts`)}
                      />
                    </clipPath>
                  </defs>
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Контакты</div>
          </div>
        </NavLink>
      )}
      {role === "участник" && isActual && (
        <NavLink to={`/${type}/${id}/settings/promotion`} activeClassName="active">
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.9511 1.5469C16.9172 1.41844 16.8499 1.30126 16.756 1.20733C16.662 1.1134 16.5449 1.04607 16.4164 1.01223C14.8779 0.612625 13.2578 0.655665 11.7426 1.1364C10.2275 1.61713 8.87891 2.51601 7.8522 3.72953L7.016 4.7224L5.0624 4.25104C4.58745 4.08546 4.06864 4.09733 3.60176 4.28445C3.13488 4.47158 2.75148 4.82131 2.52236 5.26908L0.872216 8.194C0.814398 8.29645 0.781493 8.41107 0.776161 8.52859C0.77083 8.64611 0.793221 8.76324 0.841526 8.8705C0.889831 8.97777 0.962694 9.07216 1.05423 9.14606C1.14576 9.21996 1.25339 9.27129 1.36843 9.2959L3.67299 9.78992C3.47777 10.3842 3.33838 10.9953 3.25662 11.6155C3.24179 11.7294 3.25333 11.8452 3.29035 11.954C3.32737 12.0628 3.38887 12.1616 3.47011 12.2428L5.79519 14.5679C5.8648 14.6375 5.94746 14.6928 6.03844 14.7305C6.12943 14.7682 6.22695 14.7876 6.32544 14.7876C6.34704 14.7876 6.36865 14.7865 6.39063 14.7847C7.02463 14.7277 7.65093 14.6045 8.2593 14.4172L8.74206 16.6696C8.76673 16.7846 8.8181 16.8922 8.89201 16.9837C8.96592 17.0752 9.06031 17.148 9.16756 17.1963C9.27481 17.2446 9.39191 17.267 9.50942 17.2617C9.62692 17.2564 9.74153 17.2235 9.84399 17.1658L12.7729 15.5138C13.1852 15.2633 13.5072 14.8884 13.6925 14.4431C13.8779 13.9977 13.917 13.505 13.8042 13.036L13.3027 10.9668L14.2305 10.1136C15.4485 9.08982 16.3509 7.74117 16.8325 6.22462C17.3141 4.70806 17.3552 3.08592 16.9511 1.5469ZM2.67947 8.04276L3.84658 5.97294C3.91907 5.83242 4.04258 5.72496 4.19177 5.67259C4.34096 5.62023 4.50454 5.62693 4.64895 5.69132L5.937 6.00347L5.4495 6.58231C4.98732 7.13624 4.58758 7.73941 4.25751 8.3809L2.67947 8.04276ZM12.0321 14.2094L9.99526 15.3582L9.67314 13.8547C10.3261 13.529 10.9344 13.1207 11.4832 12.6398L12.0408 12.127L12.3434 13.3755C12.3826 13.5296 12.3739 13.6921 12.3182 13.8411C12.2626 13.9902 12.1628 14.1186 12.0321 14.2094ZM13.2428 8.9854L10.4794 11.5251C9.38556 12.471 8.03636 13.0723 6.60159 13.2532L4.79836 11.45C5.04055 10.0115 5.66215 8.66364 6.59902 7.5455L7.85778 6.05099C7.87875 6.02905 7.89832 6.00581 7.91637 5.98141L8.99258 4.70365C9.78831 3.76382 10.8192 3.05201 11.98 2.64088C13.1408 2.22976 14.3899 2.13406 15.5998 2.36356C15.8348 3.57722 15.7401 4.83171 15.3256 5.99635C14.9111 7.16099 14.1918 8.19318 13.2428 8.9854ZM12.5506 4.36258C12.3281 4.36258 12.1106 4.42856 11.9256 4.55218C11.7406 4.67579 11.5964 4.8515 11.5112 5.05706C11.4261 5.26263 11.4038 5.48883 11.4472 5.70706C11.4906 5.92529 11.5977 6.12574 11.7551 6.28308C11.9124 6.44041 12.1129 6.54756 12.3311 6.59096C12.5493 6.63437 12.7755 6.61209 12.9811 6.52695C13.1867 6.4418 13.3624 6.2976 13.486 6.1126C13.6096 5.92759 13.6756 5.71008 13.6756 5.48758C13.6756 5.33984 13.6465 5.19354 13.59 5.05704C13.5334 4.92054 13.4506 4.79652 13.3461 4.69205C13.2416 4.58758 13.1176 4.50471 12.9811 4.44818C12.8446 4.39165 12.6983 4.36255 12.5505 4.36257L12.5506 4.36258Z"
                    fill={getActiveIcon(`settings/promotion`)}
                  />
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Реклама</div>
          </div>
        </NavLink>
      )}
      {isActual && (
        <NavLink
          to={`/${type}/${id}/settings/create-web`}
          onClick={() => dispatch(setClearDemoSite())}
          activeClassName="active"
        >
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ width: "18px", height: "18px" }}
                  viewBox="0 0 512 512"
                >
                  <path
                    fill={getActiveIcon(`settings/create-web`)}
                    d="M486.4,38.4H25.6C11.46,38.4,0,49.86,0,64v384c0,14.14,11.46,25.6,25.6,25.6h460.8c14.14,0,25.6-11.46,25.6-25.6V64    C512,49.86,500.54,38.4,486.4,38.4z M486.4,448H25.6V166.4h460.8V448z M486.4,140.8H25.6V64h460.8V140.8z"
                  />
                  <circle
                    fill={getActiveIcon(`settings/create-web`)}
                    cx="448"
                    cy="102.4"
                    r="12.8"
                  />
                  <circle
                    fill={getActiveIcon(`settings/create-web`)}
                    cx="396.8"
                    cy="102.4"
                    r="12.8"
                  />
                  <circle
                    fill={getActiveIcon(`settings/create-web`)}
                    cx="345.6"
                    cy="102.4"
                    r="12.8"
                  />
                  <path
                    fill={getActiveIcon(`settings/create-web`)}
                    d="m278.3 217.98c-6.929-1.783-13.824 2.449-15.522 9.31l-38.4 153.6c-1.698 6.852 2.449 13.807 9.327 15.522 1.05 0.256 2.074 0.384 3.098 0.384 5.751 0 10.974-3.874 12.425-9.702l38.4-153.6c1.697-6.853-2.451-13.799-9.328-15.514z"
                  />
                  <path
                    fill={getActiveIcon(`settings/create-web`)}
                    d="m197.73 346.95-79.505-39.748 79.497-39.748c6.323-3.166 8.875-10.846 5.726-17.178-3.174-6.34-10.829-8.866-17.178-5.726l-102.4 51.2c-4.318 2.176-7.066 6.605-7.066 11.452s2.748 9.276 7.074 11.452l102.4 51.2c1.852 0.913 3.797 1.348 5.726 1.348 4.676 0 9.199-2.586 11.452-7.074 3.149-6.323 0.597-14.012-5.726-17.178z"
                  />
                  <path
                    fill={getActiveIcon(`settings/create-web`)}
                    d="m428.13 295.75-102.4-51.2c-1.852-0.905-3.797-1.348-5.726-1.348-4.676 0-9.199 2.586-11.452 7.074-3.149 6.323-0.597 14.012 5.726 17.178l79.505 39.748-79.497 39.748c-6.332 3.166-8.883 10.854-5.734 17.178 3.174 6.34 10.829 8.866 17.178 5.726l102.4-51.2c4.326-2.176 7.074-6.596 7.074-11.452s-2.748-9.276-7.074-11.452z"
                  />
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">
              {role === "участник" && "Сайт стенда"}
              {role === "организатор" && "Сайт мероприятия"}
            </div>
          </div>
        </NavLink>
      )}
      {isActual && (
        <NavLink to={`/${type}/${id}/settings/webinar`} activeClassName="active">
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0)">
                    <path
                      d="M10.1816 3.71289H1.96937C0.886214 3.71289 0 4.59911 0 5.68226V12.319C0 13.4022 0.886214 14.2884 1.96937 14.2884H10.1816C11.2648 14.2884 12.151 13.4022 12.151 12.319V5.68226C12.151 4.57941 11.2648 3.71289 10.1816 3.71289Z"
                      fill={getActiveIcon(`settings/webinar`)}
                    />
                    <path
                      d="M16.5437 4.79539C16.4256 4.81509 16.3074 4.87417 16.2089 4.93325L13.1367 6.70567V11.2746L16.2286 13.047C16.7997 13.3818 17.5087 13.1849 17.8435 12.6138C17.942 12.4365 18.0011 12.2396 18.0011 12.023V5.93762C18.0011 5.20896 17.3118 4.61815 16.5437 4.79539Z"
                      fill={getActiveIcon(`settings/webinar`)}
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Вебинар</div>
          </div>
        </NavLink>
      )}
      {(isActual || isPast || isFilling || isRequest) && (
        <NavLink to={`/${type}/${id}/settings/document-flow`} activeClassName="active">
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.75 7.5H7.5C7.69891 7.5 7.88968 7.42098 8.03033 7.28033C8.17098 7.13968 8.25 6.94891 8.25 6.75C8.25 6.55109 8.17098 6.36032 8.03033 6.21967C7.88968 6.07902 7.69891 6 7.5 6H6.75C6.55109 6 6.36032 6.07902 6.21967 6.21967C6.07902 6.36032 6 6.55109 6 6.75C6 6.94891 6.07902 7.13968 6.21967 7.28033C6.36032 7.42098 6.55109 7.5 6.75 7.5ZM6.75 9C6.55109 9 6.36032 9.07902 6.21967 9.21967C6.07902 9.36032 6 9.55109 6 9.75C6 9.94891 6.07902 10.1397 6.21967 10.2803C6.36032 10.421 6.55109 10.5 6.75 10.5H11.25C11.4489 10.5 11.6397 10.421 11.7803 10.2803C11.921 10.1397 12 9.94891 12 9.75C12 9.55109 11.921 9.36032 11.7803 9.21967C11.6397 9.07902 11.4489 9 11.25 9H6.75ZM15 6.705C14.9922 6.6361 14.9771 6.56822 14.955 6.5025V6.435C14.9189 6.35788 14.8708 6.287 14.8125 6.225L10.3125 1.725C10.2505 1.66666 10.1796 1.61856 10.1025 1.5825C10.0801 1.57932 10.0574 1.57932 10.035 1.5825C9.95881 1.53881 9.87467 1.51076 9.7875 1.5H5.25C4.65326 1.5 4.08097 1.73705 3.65901 2.15901C3.23705 2.58097 3 3.15326 3 3.75V14.25C3 14.8467 3.23705 15.419 3.65901 15.841C4.08097 16.2629 4.65326 16.5 5.25 16.5H12.75C13.3467 16.5 13.919 16.2629 14.341 15.841C14.7629 15.419 15 14.8467 15 14.25V6.75C15 6.75 15 6.75 15 6.705ZM10.5 4.0575L12.4425 6H11.25C11.0511 6 10.8603 5.92098 10.7197 5.78033C10.579 5.63968 10.5 5.44891 10.5 5.25V4.0575ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H5.25C5.05109 15 4.86032 14.921 4.71967 14.7803C4.57902 14.6397 4.5 14.4489 4.5 14.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H9V5.25C9 5.84674 9.23705 6.41903 9.65901 6.84099C10.081 7.26295 10.6533 7.5 11.25 7.5H13.5V14.25ZM11.25 12H6.75C6.55109 12 6.36032 12.079 6.21967 12.2197C6.07902 12.3603 6 12.5511 6 12.75C6 12.9489 6.07902 13.1397 6.21967 13.2803C6.36032 13.421 6.55109 13.5 6.75 13.5H11.25C11.4489 13.5 11.6397 13.421 11.7803 13.2803C11.921 13.1397 12 12.9489 12 12.75C12 12.5511 11.921 12.3603 11.7803 12.2197C11.6397 12.079 11.4489 12 11.25 12Z"
                    fill={getActiveIcon(`settings/document-flow`)}
                  />
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Документооборот</div>
          </div>
        </NavLink>
      )}
      {(isActual || isPast) && (
        <NavLink to={`/${type}/${id}/settings/analytics`} activeClassName="active">
          <div className="nav-profile__item">
            <div className="nav-profile__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.75 15H3V14.595L6.75 10.845L9.6 13.695C9.74052 13.8347 9.93061 13.9131 10.1287 13.9131C10.3269 13.9131 10.517 13.8347 10.6575 13.695L16.2825 8.07C16.3528 8.00028 16.4086 7.91733 16.4467 7.82593C16.4847 7.73454 16.5043 7.63651 16.5043 7.5375C16.5043 7.43849 16.4847 7.34046 16.4467 7.24907C16.4086 7.15767 16.3528 7.07472 16.2825 7.005C16.142 6.86531 15.9519 6.78691 15.7537 6.78691C15.5556 6.78691 15.3655 6.86531 15.225 7.005L10.125 12.105L7.2825 9.255C7.14198 9.11531 6.95189 9.03691 6.75375 9.03691C6.55561 9.03691 6.36552 9.11531 6.225 9.255L3 12.4725V8.595L6.75 4.845L8.85 6.945C8.99052 7.08469 9.18061 7.16309 9.37875 7.16309C9.57689 7.16309 9.76698 7.08469 9.9075 6.945L13.5 3.3525L15.1425 4.995C15.2837 5.13523 15.4749 5.21362 15.6739 5.21292C15.8729 5.21221 16.0635 5.13248 16.2037 4.99125C16.344 4.85002 16.4224 4.65887 16.4217 4.45985C16.421 4.26083 16.3412 4.07023 16.2 3.93L14.0175 1.7625C13.877 1.62281 13.6869 1.54441 13.4888 1.54441C13.2906 1.54441 13.1005 1.62281 12.96 1.7625L9.36 5.3625L7.2675 3.2625C7.12698 3.12281 6.93689 3.04441 6.73875 3.04441C6.54061 3.04441 6.35052 3.12281 6.21 3.2625L3 6.4725V2.25C3 2.05109 2.92098 1.86032 2.78033 1.71967C2.63968 1.57902 2.44891 1.5 2.25 1.5C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05109 1.5 2.25V15.75C1.5 15.9489 1.57902 16.1397 1.71967 16.2803C1.86032 16.421 2.05109 16.5 2.25 16.5H15.75C15.9489 16.5 16.1397 16.421 16.2803 16.2803C16.421 16.1397 16.5 15.9489 16.5 15.75C16.5 15.5511 16.421 15.3603 16.2803 15.2197C16.1397 15.079 15.9489 15 15.75 15Z"
                    fill={getActiveIcon(`settings/analytics`)}
                  />
                </svg>
              </i>
            </div>
            <div className="nav-profile__name">Аналитика</div>
          </div>
        </NavLink>
      )}
      {statusType !== "actual" && (
        <button
          onClick={onSendClick}
          className="nav-profile__send-btn red-btn"
          disabled={!isStandMediaConfirmed}
        >
          {isLoading ? <ButtonLoader /> : "Отправить"}
        </button>
      )}
    </>
  );
};

export default NavStandIcons;
